export class DeliveryUrlHelper {
    replaceAssetDomain(originalAssetUrl, customDomain) {
        return `${customDomain}${this.getPathname(originalAssetUrl)}`;
    }
    getPathname(url) {
        return new URL(url).pathname;
    }
}
export const deliveryUrlHelper = new DeliveryUrlHelper();
//# sourceMappingURL=delivery-url.helper.js.map